module.exports = __webpack_public_path__ + "img/tn.881e1b1c.svg";